export const getCountriesWithExiros=()=>{
    return ["AR","MX","PE"]
}
export const getCountriesIdWithExiros=()=>{
    // AR: 1,
    // MX: 3,
    // PE: 6
    // This info match with DB
    return [1,3,6]
}

export const countryHasExirosByShortHand=(country)=>{
    return getCountriesWithExiros().includes(country)
}

export const countryHasExirosByCountryId=(countryId)=>{
    return getCountriesIdWithExiros().includes(countryId)
}